import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionTypeIconSpreadsheet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M20.3077 5.0769H3.69231C3.5087 5.0769 3.33261 5.14984 3.20277 5.27968C3.07294 5.40951 3 5.5856 3 5.76921V17.5384C3 17.9057 3.14588 18.2578 3.40554 18.5175C3.66521 18.7772 4.01739 18.9231 4.38462 18.9231H19.6154C19.9826 18.9231 20.3348 18.7772 20.5945 18.5175C20.8541 18.2578 21 17.9057 21 17.5384V5.76921C21 5.5856 20.9271 5.40951 20.7972 5.27968C20.6674 5.14984 20.4913 5.0769 20.3077 5.0769ZM4.38462 10.6154H7.84615V13.3846H4.38462V10.6154ZM9.23077 10.6154H19.6154V13.3846H9.23077V10.6154ZM19.6154 6.46152V9.23075H4.38462V6.46152H19.6154ZM4.38462 14.7692H7.84615V17.5384H4.38462V14.7692ZM19.6154 17.5384H9.23077V14.7692H19.6154V17.5384Z",
		fill: "currentColor"
	}) })
});
export default SvgQuestionTypeIconSpreadsheet;
